module.exports = __webpack_public_path__ + "static/media/bg-lg.6b7b727e.jpg";